module.exports = __webpack_public_path__ + "img/Thai_QR_Payment_Logo-03.cfd19621.png";